import{FindValueOperator as n}from"./find.js";function r(r,t){return function(f){return f.lift(new n(r,f,!0,t))}}export{r as findIndex};
